/* ================================================
   Messoanuovo — Prenota Videochiamata
   Wizard 2 step + Cal.com iframe embed
   June 2026
   ================================================ */

(function () {
  'use strict';

  /* ── Cal.com slug degli event types ──────────────────────────
     Sostituisci YOUR_CAL_USERNAME con il tuo username Cal.com
     e gli slug con quelli esatti dei tuoi 3 event types
  ────────────────────────────────────────────────────────────── */
  var CAL_URLS = {
    info:     'computer-service-5s2dk3/info-prodotto',
    demo:     'computer-service-5s2dk3/demo-dal-vivo'
  };;

  var CAL_BASE = 'https://cal.com/';

  /* ── Stato ── */
  var currentType = null;

  /* ── Elementi DOM ── */
  var step1      = document.getElementById('mn-vc-step-1');
  var step2      = document.getElementById('mn-vc-step-2');
  var stepItems  = document.querySelectorAll('.mn-vc-step-item');
  var selCards   = document.querySelectorAll('.mn-vc-sel-card');
  var btnNext1   = document.getElementById('mn-vc-btn-next-1');
  var btnBack2   = document.getElementById('mn-vc-btn-back-2');
  var calIframe  = document.getElementById('mn-vc-cal-iframe');
  var typeBadge  = document.getElementById('mn-vc-type-badge');
  var errorMsg   = document.getElementById('mn-vc-step-1-error');

  /* ── Aggiorna stepper visivo ── */
  function setStep(n) {
    step1.classList.toggle('active', n === 1);
    step2.classList.toggle('active', n === 2);

    stepItems.forEach(function (el) {
      var s = parseInt(el.dataset.step, 10);
      el.classList.remove('active', 'done');
      if (s === n) el.classList.add('active');
      if (s < n)  el.classList.add('done');
    });

    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  /* ── Selezione card tipo ── */
  selCards.forEach(function (card) {
    card.addEventListener('click', function () {
      selCards.forEach(function (c) { c.classList.remove('selected'); });
      card.classList.add('selected');
      currentType = card.dataset.type;
      btnNext1.disabled = false;
      if (errorMsg) errorMsg.textContent = '';
    });
  });

  /* ── Step 1 → Step 2 ── */
  btnNext1.addEventListener('click', function () {
    if (!currentType) {
      if (errorMsg) errorMsg.textContent = 'Seleziona un tipo di chiamata per procedere.';
      return;
    }

    var labels = {
      info:     '📋 Info Prodotto',
      demo:     '👁️ Demo dal Vivo'
  };;
    if (typeBadge) typeBadge.textContent = labels[currentType] || '';

    var slug = CAL_URLS[currentType];
    if (calIframe && slug) {
      calIframe.src = CAL_BASE + slug + '?embed=true&layout=month_view&theme=light&hideEventTypeDetails=0&hideLandingPageDetails=0';
    }

    setStep(2);
  });

  /* ── Step 2 → Step 1 ── */
  btnBack2.addEventListener('click', function () {
    if (calIframe) calIframe.src = 'about:blank';
    setStep(1);
  });

})();


